// import React, { useState } from "react";
// import Card from "components/card";
// import { MdClose } from "react-icons/md";
// import { FaHotel } from "react-icons/fa";

// const HotelModal = ({ isOpen, onClose, onAdd, editingItem }) => {
//   const [formData, setFormData] = useState({
//     name: "",
//     type: "",
//     location: "",
//     price: "",
//     checkIn: "",
//     checkOut: ""
//   });

//   React.useEffect(() => {
//     if (editingItem) {
//       setFormData({
//         name: editingItem.name || "",
//         type: editingItem.type || "",
//         location: editingItem.location || "",
//         price: editingItem.price || "",
//         checkIn: editingItem.checkIn || "",
//         checkOut: editingItem.checkOut || ""
//       });
//     } else {
//       setFormData({ name: "", type: "", location: "", price: "", checkIn: "", checkOut: "" });
//     }
//   }, [editingItem, isOpen]);

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     onAdd(formData);
//     setFormData({ name: "", type: "", location: "", price: "", checkIn: "", checkOut: "" });
//     onClose();
    
//     // Trigger auto-save by dispatching custom event
//     setTimeout(() => {
//       window.dispatchEvent(new CustomEvent('cartesUpdated'));
//     }, 600);
//   };

//   if (!isOpen) return null;

//   return (
//     <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60 backdrop-blur-sm">
//       <Card extra="w-[500px] max-h-[90vh] overflow-y-auto">
//         <div className="bg-gradient-to-r from-green-500 to-green-600 p-6 rounded-t-[20px]">
//           <div className="flex items-center justify-between">
//             <div className="flex items-center space-x-3">
//               <div className="rounded-full bg-white p-2">
//                 <FaHotel className="h-6 w-6 text-green-500" />
//               </div>
//               <h3 className="text-2xl font-bold text-white">{editingItem ? 'Edit Hotel Details' : 'Add Hotel Details'}</h3>
//             </div>
//             <button onClick={onClose} className="rounded-full bg-white/20 p-2 text-white hover:bg-white/30">
//               <MdClose className="h-6 w-6" />
//             </button>
//           </div>
//         </div>
        
//         <form onSubmit={handleSubmit} className="p-6 space-y-6">
          
//           <div>
//             <label className="block text-sm font-semibold text-navy-700 dark:text-white mb-2">Location</label>
//             <input
//               type="text"
//               placeholder="e.g., Downtown LA"
//               value={formData.location}
//               onChange={(e) => setFormData({...formData, location: e.target.value})}
//               className="w-full rounded-xl border-2 border-gray-200 p-3 focus:border-green-500 focus:outline-none dark:border-gray-600 dark:bg-navy-800 dark:text-white transition-colors"
//               required
//             />
//           </div>
          
//           <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//             <div>
//               <label className="block text-sm font-semibold text-navy-700 dark:text-white mb-2">Check-in Date</label>
//               <input
//                 type="date"
//                 value={formData.checkIn}
//                 onChange={(e) => setFormData({...formData, checkIn: e.target.value})}
//                 className="w-full rounded-xl border-2 border-gray-200 p-3 focus:border-green-500 focus:outline-none dark:border-gray-600 dark:bg-navy-800 dark:text-white transition-colors"
//                 required
//               />
//             </div>
//             <div>
//               <label className="block text-sm font-semibold text-navy-700 dark:text-white mb-2">Check-out Date</label>
//               <input
//                 type="date"
//                 value={formData.checkOut}
//                 onChange={(e) => setFormData({...formData, checkOut: e.target.value})}
//                 className="w-full rounded-xl border-2 border-gray-200 p-3 focus:border-green-500 focus:outline-none dark:border-gray-600 dark:bg-navy-800 dark:text-white transition-colors"
//                 required
//               />
//             </div>
            
//           </div>
          
//           <div className="flex space-x-4 pt-4">
//             <button
//               type="submit"
//               className="flex-1 rounded-xl bg-gradient-to-r from-green-500 to-green-600 py-3 px-6 text-white font-semibold hover:from-green-600 hover:to-green-700 transform hover:scale-105 transition-all duration-200 shadow-lg"
//             >
// {editingItem ? 'Update Hotel' : 'Add Hotel'}
//             </button>
//             <button
//               type="button"
//               onClick={onClose}
//               className="flex-1 rounded-xl bg-gray-100 py-3 px-6 text-gray-700 font-semibold hover:bg-gray-200 dark:bg-gray-700 dark:text-gray-300 dark:hover:bg-gray-600 transition-colors"
//             >
//               Cancel
//             </button>
//           </div>
//         </form>
//       </Card>
//     </div>
//   );
// };

// export default HotelModal;

import React, { useState, useEffect } from "react";
import Card from "components/card";
import { MdClose } from "react-icons/md";
import { FaHotel } from "react-icons/fa";

// Dummy hotels
const dummyHotels = [
  { id: 1, name: "Grand LA Hotel", type: "5-Star", location: "Downtown LA", price: "250" },
  { id: 2, name: "Sunset Inn", type: "3-Star", location: "Hollywood", price: "150" },
  { id: 3, name: "Oceanview Resort", type: "4-Star", location: "Santa Monica", price: "200" },
];

const HotelModal = ({ isOpen, onClose, onAdd, editingItem }) => {
  const [formData, setFormData] = useState({
    location: "",
    checkIn: "",
    checkOut: ""
  });
  const [availableHotels, setAvailableHotels] = useState([]);
  const [selectedHotel, setSelectedHotel] = useState(null);
  const [searching, setSearching] = useState(false);

  const getTodayDate = () => {
    const d = new Date();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${d.getFullYear()}-${month}-${day}`;
  };

  const getTomorrowDate = () => {
    const d = new Date();
    d.setDate(d.getDate() + 1);
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${d.getFullYear()}-${month}-${day}`;
  };

  useEffect(() => {
    if (editingItem) {
      setFormData({
        location: editingItem.location || "",
        checkIn: editingItem.checkIn || getTodayDate(),
        checkOut: editingItem.checkOut || getTomorrowDate(),
      });
      setSelectedHotel(editingItem);
    } else {
      setFormData({
        location: "",
        checkIn: getTodayDate(),
        checkOut: getTomorrowDate(),
      });
      setSelectedHotel(null);
    }
    setAvailableHotels([]);
  }, [editingItem, isOpen]);

  const handleSearch = () => {
    if (!formData.location || !formData.checkIn || !formData.checkOut) {
      alert("Please enter location and dates to search");
      return;
    }
    setSearching(true);
    setTimeout(() => {
      // Always show dummy hotels
      setAvailableHotels(dummyHotels);
      setSearching(false);
    }, 500);
  };

  const handleSelectHotel = (hotel) => {
    setSelectedHotel(hotel);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!selectedHotel) {
      alert("Please select a hotel first");
      return;
    }
    const finalData = { ...formData, ...selectedHotel };
    onAdd(finalData);
    onClose();

    // Trigger auto-save event
    setTimeout(() => {
      window.dispatchEvent(new CustomEvent("cartesUpdated"));
    }, 600);
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60 backdrop-blur-sm">
      <Card extra="w-[500px] max-h-[90vh] overflow-y-auto">
        <div className="bg-gradient-to-r from-green-500 to-green-600 p-6 rounded-t-[20px]">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-3">
              <div className="rounded-full bg-white p-2">
                <FaHotel className="h-6 w-6 text-green-500" />
              </div>
              <h3 className="text-2xl font-bold text-white">{editingItem ? 'Edit Hotel Details' : 'Add Hotel Details'}</h3>
            </div>
            <button onClick={onClose} className="rounded-full bg-white/20 p-2 text-white hover:bg-white/30">
              <MdClose className="h-6 w-6" />
            </button>
          </div>
        </div>

        <div className="p-6 space-y-4">
          {/* Search Form */}
          <div>
            <label className="block text-sm font-semibold text-navy-700 dark:text-white mb-2">Location</label>
            <input
              type="text"
              placeholder="e.g., Downtown LA"
              value={formData.location}
              onChange={(e) => setFormData({ ...formData, location: e.target.value })}
              className="w-full rounded-xl border-2 border-gray-200 p-3 focus:border-green-500 focus:outline-none dark:border-gray-600 dark:bg-navy-800 dark:text-white transition-colors"
            />
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-semibold text-navy-700 dark:text-white mb-2">Check-in Date</label>
              <input
                type="date"
                value={formData.checkIn}
                onChange={(e) => setFormData({ ...formData, checkIn: e.target.value })}
                className="w-full rounded-xl border-2 border-gray-200 p-3 focus:border-green-500 focus:outline-none dark:border-gray-600 dark:bg-navy-800 dark:text-white transition-colors"
              />
            </div>
            <div>
              <label className="block text-sm font-semibold text-navy-700 dark:text-white mb-2">Check-out Date</label>
              <input
                type="date"
                value={formData.checkOut}
                onChange={(e) => setFormData({ ...formData, checkOut: e.target.value })}
                className="w-full rounded-xl border-2 border-gray-200 p-3 focus:border-green-500 focus:outline-none dark:border-gray-600 dark:bg-navy-800 dark:text-white transition-colors"
              />
            </div>
          </div>

          <button
            onClick={handleSearch}
            disabled={searching}
            className="w-full bg-green-500 text-white py-3 rounded-xl font-semibold hover:bg-green-600 transition-colors"
          >
            {searching ? "Searching..." : "Search Hotels"}
          </button>

          {/* Hotel list */}
          {availableHotels.length > 0 && (
            <div className="mt-4 space-y-2 max-h-64 overflow-y-auto">
              {availableHotels.map(hotel => (
                <div
                  key={hotel.id}
                  onClick={() => handleSelectHotel(hotel)}
                  className={`p-3 border rounded-xl cursor-pointer flex justify-between items-center ${
                    selectedHotel?.id === hotel.id ? 'border-green-500 bg-green-50' : 'border-gray-200 hover:bg-gray-100'
                  }`}
                >
                  <div>
                    <p className="font-semibold">{hotel.name}</p>
                    <p className="text-sm text-gray-500">{hotel.type} - {hotel.location}</p>
                  </div>
                  <p className="font-semibold">${hotel.price}</p>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Footer */}
        <div className="p-6 flex gap-4">
          <button
            onClick={handleSubmit}
            disabled={!selectedHotel}
            className="flex-1 bg-gradient-to-r from-green-500 to-green-600 text-white py-3 rounded-xl font-semibold hover:from-green-600 hover:to-green-700 transform hover:scale-105 transition-all duration-200 disabled:opacity-50"
          >
            {editingItem ? 'Update Hotel' : 'Add Hotel'}
          </button>
          <button
            onClick={onClose}
            className="flex-1 bg-gray-100 py-3 rounded-xl font-semibold hover:bg-gray-200 transition-colors"
          >
            Cancel
          </button>
        </div>
      </Card>
    </div>
  );
};

export default HotelModal;
